import React from 'react';
import styled from 'styled-components';

const BarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  flex: 1;
`;

const BarWrapper = styled.div`
  height: 320px;
  width: 12px;
  background: #eee;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

const BarProgress = styled.div`
  background: ${({ color }) => color};
  height: ${({ value }) => `${value}%`};
  width: 100%;
  color: transparent;
`;

const BarLabel = styled.a`
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.label};
  margin: 0px 5px;
`;

export default ({ color, value, label }) => {
  return (
    <BarContainer>
      <BarWrapper>
        <BarProgress color={color} value={value} />
      </BarWrapper>
      <BarLabel>{label}</BarLabel>
    </BarContainer>
  );
};
